import {SET_MODE} from 'shared/constants/ActionTypes';

const INIT_STATE = {
  mode: 'portal',
};

export const setModeAppReducers = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_MODE:
      return {
        ...state,
        mode: action.payload,
      };
    default:
      return state;
  }
};

export default setModeAppReducers;
